<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Empresas Comex</h1>
          <b-spinner v-if="loading" variant="primary" class="ml-2" small label="Small Spinner"></b-spinner>
        </b-col>
        <b-col>
          <b-button class="float-right" :href="createCompanyUrl()" target="_blank"
            >Crear empresa <i class="fa fa-ga fa-external-link ml-1"></i
          ></b-button>
        </b-col>
      </b-row>
      <b-row v-for="(item, index) in Object.keys(items)" :key="index">
        <b-col>
          <b-card :title="item" :sub-title="item" :show-footer="true" class="mb-2">
            <b-card-text>
              <b-table
                :items="items[item]"
                :fields="['name']"
                :busy="loading"
                :bordered="true"
                :small="true"
                :striped="true"
                :hover="true"
                :outlined="true"
                :head-variant="'dark'"
              >
                <template #cell(name)="data">
                  <a :href="companyAdminUrl(data.item.id)" target="_blank"
                    >{{ data.item.name }}
                    <i class="fa fa-external-link"></i>
                  </a>
                </template>
              </b-table>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "Empresas",
  data() {
    return {
      loading: false,
      items: []
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/api/v1/empresas_comex/?fields=name,id");
        this.items = response.data;
      } catch {
        this.$toast.error("Error al cargar los datos");
      } finally {
        this.loading = false;
      }
    },
    companyAdminUrl(id) {
      return this.baseUrlAdmin + `/production/company/${id}/change/`;
    },
    createCompanyUrl() {
      return this.baseUrlAdmin + "/production/company/add/";
    }
  },
  computed: {
    baseUrlAdmin() {
      return localStorage.getItem("packapp_api_url") + "/admin";
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
<style></style>
